<script>
import * as tus from 'tus-js-client'

export default {
  name: 'VimeoMixin',
  methods: {
    uploadVimeoVideo(fileObj, uploadUrl) {
      return new Promise((resolve, reject) => {
        if (!this.$validate.DataValid(uploadUrl)) {
          reject('upload url not found')
          return
        }

        var upload = new tus.Upload(fileObj, {
          uploadUrl: uploadUrl,
          onError: error => {
            this.$common.error(error)
            reject(error)
          },
          onProgress: (bytesUploaded, bytesTotal) => {},
          onSuccess: () => {
            this.$common.logData(upload, '--- upload vimeo video success ---')
            resolve({ name: upload.file.name, url: upload.url })
          },
        })

        upload.start()
      })
    },
    removeUnusedVimeoVideo(removeList = []) {
      return new Promise(async (resolve, reject) => {
        try {
          const getUser = this.gfGetCurrentUserData()
          if (removeList.length > 0) {
            const data = await this.$Fetcher.DeleteUnusedVimeoVideo(
              removeList,
              getUser.access_token,
              getUser.refresh_token,
            )
            // save the new access token (if any)
            if (this.$validate.DataValid(data.access_token)) {
              this.gfUpdateUserAccessToken(data.access_token)
            }
          }

          this.$store.dispatch('resetRemovedVimeoVideoID', [])
          resolve(true)
        } catch (err) {
          this.$common.error(err)
          this.$store.dispatch('resetRemovedVimeoVideoID', [])
          resolve(false)
        }
      })
    },
  },
}
</script>
